import { withStyles } from "@material-ui/core/styles";
import "date-fns";
import "fontsource-roboto";
import $ from "jquery";
import {
  Paper,
  Grid,
  Card,
  CardContent,
  Typography,
  Link,
  Divider,
} from "@material-ui/core";
import React, { Component } from "react";
import { formateDate, getQueryVariable } from "../utils/utilTools";
import Pagination from "@material-ui/lab/Pagination";
import { VideoLibrary, Flag, FindInPage } from "@material-ui/icons";
import SearchNoResult from "./search-noResult";

require("../assets/css/style.css");
require("../assets/css/news-style.css");
const imageAccount = require("../assets/images/top-ico1.png");
const searchTitle = require("../assets/images/gw.png");

const useStyles = {
  root: {
    "& > *": {
      width: "65ch",
    },
  },
  inputText: {
    padding: "0 5px 0 0",
  },
  breakLine: {
    margin: "20px 0 0 0",
  },
  breakLineInset: {
    margin: "20px 0 0 16px",
  },
};

class Pagepre extends Component {
  constructor(props) {
    super();
  }

  componentWillUnmount = () => {};

  componentDidMount() {}

  componentDidCatch(error, errorInfo) {
    console.log("==============", error, errorInfo);
  }

  render() {
    let {classname} = this.props;
    return (
      <button
        class={"MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-page MuiPaginationItem-outlined " + classname}
        tabindex="0"
        type="button"
        aria-label="Go to previous page"
      >
        <svg
          class="MuiSvgIcon-root MuiPaginationItem-icon"
          focusable="false"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
        </svg>
        <span class="MuiTouchRipple-root"></span>
        {/* <img src={require("../assets/images/filesicon.png")} /> */}
      </button>
    );
  }
}

export default withStyles(useStyles)(Pagepre);
